// eslint-disable-next-line import/prefer-default-export
export var SIZES = {
  arrowHeight: 5,
  arrowWidth: 11,
  offsetWithArrow: 2,
  offsetWhenArrowHidden: 7
};